// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3ccyy","abort":"style_abort__3pqO6","register":"style_register__3ojWs"};